import { IUnit } from 'src/app/dashboard/pos/schema/pos/product';
import { IAppointment } from './appointment';

export interface IItemCategory {
  id: number;
  name: string;
  icon: string;
  nonSelectedImage: string;
  selectedImage: string;
}

export enum ItemType {
  service = 1, //خدمة
  product = 2, //منتج
  session = 3, //جلسة

  productUnit = 4, //وحدة منتج
  package = 5, //باقة
  giftCard = 6, //كارت هدية
  gymMembership = 7, //اشتراك نادي
  voucher = 8,
}

export interface ItemModel {
  id: number;
  itemId: number;
  itemType: ItemType;
  name: string;
  currency?: string;
  isMultiEmployees?: boolean;
  price?: number;
  priceAfterOffer?: number;
  itemCategory?: string;
  duration?: number;
  quantity?: number;
  unitId?: number;
  units?: IUnit[];
  isMultiTimeSlot?: boolean;
  appointment?: IAppointment;
  children?: ItemModel[];
  products?: ItemModel[];
  cardValue?: number;
  phoneNumber?: string;
  countryCode?: string;
  isForMe?: boolean;
  allowMultipleEmployees?: boolean;
  image?: string;
}

export interface IItem {
  id: number;
  itemId: number;
  name: string;
  isInCart: boolean;
}

export class IItemParams {
  pageNumber?: number;
  pageSize?: number;
  freeText?: string;
}

export enum ItemPlace {
  OnSite = 0,
  Home = 2,
  Both = 1,
}

export enum AppointmentPlace {
  OnSite = 0,
  Home = 1,
}
